// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__dMWwi","popupContainer":"styles_popupContainer__JjA1D"};